import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { DateStyles } from '../../constants/CentricConstants';
import RaisedButton from 'material-ui/RaisedButton';
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';

import EventIcon from 'material-ui/svg-icons/action/event';

const EventSegment = (props) => {
    if (!props.events) { return null; } // guard

    let subtitle = '';
    let eventData;
    let actions = [];

    let buttonLabel;
    if (props.events.length === 0) {
        subtitle = 'Available places';
        eventData = (<div key="events"><p>TBA</p></div>);
        buttonLabel = 'enrol';
    } else {
        subtitle = !props.booked ? 'Available places' : 'Attending';
        buttonLabel = !props.booked ? 'book now' : 'unbook';
        eventData = (
            <div key="events" >
                <p>
                    {props.events.map((event) => (
                        <span key={`evt_${event.id}`}>
                            <Link to={`/dashboard/event/${event.id}`}>
                                {(new Date(event.timeStart)).toLocaleString('en-GB', DateStyles.fullDateTime)}
                                {!!event.venue && ` - ${event.venue}`}
                            </Link>
                            <br />
                        </span>
                    ))}
                </p>
                {!!props.showAllEventsLink && (<p><Link to={`/dashboard/module/${props.id}/events`}>Show all</Link></p>)}
            </div>
        );
    }

    if (!!buttonLabel && !!props.bookingAction) {
        actions.push(
            <RaisedButton
                key="lft_book"
                className="button-raised"
                label={buttonLabel}
                onTouchTap={props.bookingAction}
                secondary={!props.booked}
                fullWidth
            />
        );
    }

    if (!!props.cancelAction) {
        actions.push(
            <RaisedButton
                key="lft_cancel"
                className="button-raised"
                label="unenrol"
                onTouchTap={props.cancelAction}
                fullWidth
            />
        );
    }

    return (
        <Card className="cent-card" key="eventSegment">
            <CardHeader
                title="Events"
                subtitle={subtitle}
                avatar={(<EventIcon color="rgba(117, 117, 117 ,0.7)" />)}
            />
            <CardText className="cent-card-text">
                {eventData}
            </CardText>
            {actions.length > 0 && (
                <CardActions className="cent-card-actions">
                    {actions}
                </CardActions>
            )}
        </Card>
    );
};

EventSegment.propTypes = {
    id:                 PropTypes.number,
    events:             PropTypes.arrayOf(PropTypes.object),
    booked:             PropTypes.bool,
    bookingAction:      PropTypes.func,
    cancelAction:       PropTypes.func,
    showAllEventsLink:  PropTypes.bool
};

export default EventSegment;
